var map = {
	"./english.json": [
		34456,
		557
	],
	"./german.json": [
		8924,
		195
	],
	"./japanese.json": [
		59348,
		483
	],
	"./korean.json": [
		76489,
		426
	],
	"./mandarin.json": [
		82903,
		275
	],
	"./portugese.json": [
		63732,
		172
	],
	"./portuguese.json": [
		40249,
		243
	],
	"./spanish.json": [
		75012,
		174
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28364;
module.exports = webpackAsyncContext;